import BrevetScreenNavigationItem from "../../items/brevetScreen/BrevetScreenNavigationItem";
import {kBrevetNavigation} from "../../../constants/navigation";

export default function BrevetScreenNavigationHeader({selectedBrevetScreen, setSelectedBrevetScreen}) {
    // Used in BrevetScreen to display header for navigation

    // BUILD
    return (
        <div className={"w-full h-[48px] min-h-[48px] flex justify-start items-end space-x-[16px] px-[16px] border-b-[1px] border-greyLight5"}>
            {kBrevetNavigation.map((item, index) => (
                <BrevetScreenNavigationItem key={index}
                                            icon={item.icon}
                                            name={item.name}
                                            isSelected={selectedBrevetScreen === item.name}
                                            onClick={() => setSelectedBrevetScreen(item.name)} />
            ))}
        </div>
    );
}